/**
 * Generic function to determine display text based on an array of items
 * - If length > 1: return multipleText (default: "Multiple Items")
 * - If length === 1: return the value extracted by getDisplayValue
 * - If length === 0: return emptyText (default: "-")
 */
export const getDisplayFromArray = <T>(
	items: T[] | null | undefined,
	getDisplayValue: (item: T) => string,
	multipleText = 'Multiple Items',
	emptyText = '-',
): string => {
	if (!items || items.length === 0) {
		return emptyText;
	}

	if (items.length > 1) {
		return multipleText;
	}

	return getDisplayValue(items[0]);
};